"use strict";
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M7.75 8H11v5H7.75v1h.75c1.38 0 2.5 1.12 2.5 2.5S9.88 19 8.5 19h-.75v4h-1.5v-4H5.5C4.12 19 3 17.88 3 16.5S4.12 14 5.5 14h.75v-1H3V8h3.25V7H5.5C4.12 7 3 5.88 3 4.5S4.12 2 5.5 2h.75V1h1.5v1h.75C9.88 2 11 3.12 11 4.5S9.88 7 8.5 7h-.75zm10-1h.75C19.88 7 21 5.88 21 4.5S19.88 2 18.5 2h-.75V1h-1.5v1h-.75C14.12 2 13 3.12 13 4.5S14.12 7 15.5 7h.75v1H13v5h3.25v1h-.75c-1.38 0-2.5 1.12-2.5 2.5s1.12 2.5 2.5 2.5h.75v4h1.5v-4h.75c1.38 0 2.5-1.12 2.5-2.5S19.88 14 18.5 14h-.75v-1H21V8h-3.25z"
}), 'KebabDining');